import { Api } from '@/api'
const state = {
  needUpdateFileList: false,
  curStageInfo: null,
  nextStageInfo: null,
  leftBarTopRadio: '', // 应聘者管理-左侧栏顶部按钮选中状态
  functionBtnList: [], // 简历详情-阶段功能按钮
  functionBtnListByApi: [], // 简历详情-阶段功能按钮-接口返回原始的
  detailIsAllProfile: false, // 简历详情是否选中所有应聘者资料
  detailCurrentJob: false, // 简历详情当前选中职位
  tempLibraryType: null, // 临时显示所有应聘者资料
  needContrlByTalentConfig: null, // 需要用人才库配置控制tab(原始简历、招聘记录等)
  isWebsite: false, // 是不是官网内嵌的
  checkUserInTalent: null, // 简历当前是否处于人才库中
  processType: 0,// 0-社招   1-校招
  allListFields: {},
  interviewRequiredSet: {
    init: false,
    checkRequired: 0,
    requiredInstanceCodes: []
  },
  currentDrawerMode: 'single',
  transferredNoPermission: false, // 简历被移交走了，并且没权限
  hasPermissionEdit: false, // 是否有编辑权限
  hasPermissionDel: false, // 是否有删除权限
}
const mutations = {
  setNeedUpdateFileList(state, value) {
    state.needUpdateFileList = value
  },
  setCurStageInfo(state, value) {
    state.curStageInfo = value
  },
  setNextStageInfo(state, value) {
    state.nextStageInfo = value
  },
  setLeftBarTopRadio(state, value) {
    state.leftBarTopRadio = value
  },
  setFunctionBtnList(state, value) {
    // console.log(value, 'eq======value')
    state.functionBtnList = value
  },
  setFunctionBtnListByApi(state, value) {
    // console.log(value, 'eq======functionBtnListByApi')
    state.functionBtnListByApi = value
  },
  setDetailIsAllProfile(state, value) {
    // console.log(value, 'eq======setDetailIsAllCandidateProfile')
    state.detailIsAllProfile = value
  },
  setDetailCurrentJob(state, value) {
    // console.log(value, 'eq======detailCurrentJob')
    state.detailCurrentJob = value
  },
  setTempLibraryType(state, value) {
    // console.log(value, 'eq======setTempLibraryType')
    state.tempLibraryType = value
  },
  setNeedContrlByTalentConfig(state, value) {
    console.log(value, 'eq======setNeedContrlByTalentConfig')
    state.needContrlByTalentConfig = value
  },
  setIsWebsite(state, value) {
    state.isWebsite = value
  },
  setCheckUserIsInTalent(state, value) {
    // console.log(value, 'eq======checkUserInTalent')
    state.checkUserInTalent = value
  },
  setProcessType(state, value) {
    state.processType = value
  },
  setInterviewRequiredInstanceCodes(state, value){
    state.interviewRequiredSet = {
      init: true,
      checkRequired: value.checkRequired,
      requiredInstanceCodes: value.requiredInstanceCodes
    }
  },
  setAllListFields(state, value){
    let arr = []
    for (const key in value) {
      const element = value[key];
      if(element && element.length > 0){
        element.map(item => {
          arr[item.instanceCode] = item.displayName
        });
      }
    }
    state.allListFields = arr
  }
}
const actions = {
  async getInterviewRequiredInstanceCodes({ commit }) {
    const res =  await Api.queryInterviewEvaluateInSetting({ type: 23 })
    if (res.code === '0') {
      commit('setInterviewRequiredInstanceCodes', res.data?.rule)
      return res.data?.rule
    }
  },
  async getListFieldsClassifyByCustom({ commit }) {
    const res = await Api.listFieldsClassifyByCustom({
      objectCode: "resume",
      layoutPageType: 0,
      exceptSystemField: 1,
      isNoSpecial: 1
    })
    if (res.code === '0') {
      commit('setAllListFields', res.data)
      return res.data
    }
  },
}
export default {
  namespaced: true,
  state,
  mutations,
  actions
}

